module.exports = __webpack_public_path__ + "static/media/NSP01@l.56b0fd12.jpg";